import { render, staticRenderFns } from "./NovaDevolucao.vue?vue&type=template&id=1852c9b6&"
import script from "./NovaDevolucao.vue?vue&type=script&lang=js&"
export * from "./NovaDevolucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports